import Api from '@/api/Api'

class MyCart extends Api {
  protected resource = 'my-cart'

  public async sync<T>(request: CartSyncRequest) {
    const { data, error, response } = await this.fetch<T>(this.resource).post(request).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async reset<T>() {
    const { data, error, response } = await this.fetch<T>(this.resource).delete().json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async deleteSelected<T>() {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/delete-selected`)
      .delete()
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async storeItem<T>(request: CartAddItemRequest) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/items`)
      .post(request)
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async updateItem<T>(itemId: number, request: CartUpdateItemRequest) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/items/${itemId}`)
      .patch(request)
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async deleteItem<T>(itemId: number) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/items/${itemId}`)
      .delete()
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new MyCart()
